import { FC } from 'react';

import { Link2 } from 'lucide-react';

import { ErrorMessage, SuccessMessage, TrackMessage, TrackType } from '@/constants';

const replaceMessageTemplate = (message: string, name?: string) => {
  return name ? message?.replace('{name}', name) : message;
};

const variants = {
  pending: TrackMessage,
  error: ErrorMessage,
  success: SuccessMessage,
};

export const Message: FC<{
  type: TrackType;
  variant: keyof typeof variants;
  name?: string;
  txId?: string;
  message?: string;
}> = ({ type, variant, name, txId, message }) => {
  return (
    <div className="flex items-end gap-2">
      {`${replaceMessageTemplate(variants[variant][type], name)}${message ? `: ${message}` : ''}`}
      {['error', 'success'].includes(variant) && txId && (
        <a href={`${import.meta.env.VITE_EXPLORER_URL}/?search=${txId}`} target="_blank" rel="noopener noreferrer">
          <Link2 size={16} />
        </a>
      )}
    </div>
  );
};
